import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { disableAllMenu } from 'modules/actions/statusMenu';

const CloseChat = () => {
  const dispatch = useDispatch();
  const closed = () => {
    dispatch(disableAllMenu());
  };
  return (
    <div className="_reset_bg">
      <div className="reset_area">
        <button type="button" aria-label="닫기" title="종료 창 닫기" className="_close_btn_div" onClick={closed} >
          <i className="ri-close-line-2" />
        </button>

        <div className="fd_name">챗봇 창이 종료됩니다.</div>
        <button type="button"
          title="확인"
          className="fd_send_btn"
          onClick={() => {
            // 창 닫을 때 부모창으로 메세지 전송
            window.opener.postMessage('closeChatBot', '*');
            window.close();
          }}
        >
          확인
        </button>
      </div>
    </div>
  );
};

export default CloseChat;
